module.exports = __webpack_public_path__ + "img/55c37b6.png";